"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactModule = __importStar(require("./react"));
__export(require("./react"));
exports.react = reactModule;
exports.mapObj = function (obj, pred) {
    var mappedObj = {};
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], val = _a[1];
        mappedObj[key] = pred(val);
    });
    return mappedObj;
};
exports.mapObjToMap = function (obj, pred) {
    var mapped = new Map();
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], val = _a[1];
        mapped.set(key, pred(val));
    });
    return mapped;
};
exports.isNil = function (x) { return x === null || x === undefined; };
exports.filterNils = function (arr) {
    return arr.filter(function (x) { return !exports.isNil(x); });
};
var UnimplementedError = /** @class */ (function (_super) {
    __extends(UnimplementedError, _super);
    function UnimplementedError(message) {
        return _super.call(this, message || 'Not yet implemented') || this;
    }
    return UnimplementedError;
}(Error));
exports.UnimplementedError = UnimplementedError;
var UnreachableException = /** @class */ (function (_super) {
    __extends(UnreachableException, _super);
    function UnreachableException(message) {
        return _super.call(this, message || 'Entered unreachable code') || this;
    }
    return UnreachableException;
}(Error));
exports.UnreachableException = UnreachableException;
/**
 * Returns a memoized version of the provided function that remembers the most recent set of arguments that it was called
 * with and the result of the function called with those arguments.  If it is called again with the same arguments
 * (referentially equal), the exact same return value as last time will be returned.
 */
function memoizeOne(fn) {
    var lastArgs = null;
    var lastRes;
    var memoized = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (lastArgs !== null &&
            args.length === lastArgs.length &&
            args.forEach(function (arg, i) { return arg === lastArgs[i]; })) {
            return lastRes;
        }
        lastArgs = args;
        lastRes = fn.apply(void 0, args);
        return lastRes;
    };
    return memoized;
}
exports.memoizeOne = memoizeOne;
var AsyncOnce = /** @class */ (function () {
    function AsyncOnce(getter) {
        this.pending = null;
        this.getter = getter;
    }
    AsyncOnce.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.res) {
                    return [2 /*return*/, this.res.value];
                }
                if (this.pending) {
                    return [2 /*return*/, this.pending];
                }
                this.pending = new Promise(function (resolve) {
                    return _this.getter().then(function (res) {
                        _this.res = { value: res };
                        _this.pending = null;
                        resolve(res);
                    });
                });
                return [2 /*return*/, this.pending];
            });
        });
    };
    return AsyncOnce;
}());
exports.AsyncOnce = AsyncOnce;
//# sourceMappingURL=index.js.map